import { render, staticRenderFns } from "./MainMenuTmp.vue?vue&type=template&id=ee085352&scoped=true"
import script from "./MainMenuTmp.vue?vue&type=script&lang=js"
export * from "./MainMenuTmp.vue?vue&type=script&lang=js"
import style0 from "./MainMenuTmp.vue?vue&type=style&index=0&id=ee085352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee085352",
  null
  
)

export default component.exports